module.exports = __webpack_public_path__ + "static/media/spoke-blue.e29c6104.svg";